import { render, staticRenderFns } from "./Macdecs.vue?vue&type=template&id=53045a44&scoped=true"
import script from "./Macdecs.vue?vue&type=script&lang=js"
export * from "./Macdecs.vue?vue&type=script&lang=js"
import style0 from "./Macdecs.vue?vue&type=style&index=0&id=53045a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53045a44",
  null
  
)

export default component.exports